const Form        = require("app/components/forms/DynamicForm");
const env         = require("app/services/env");
const assign      = require("object-assign");
const ZipField    = require("app/components/fields/ZipCity");
const DateField   = require("app/components/fields/Pikaday");
const TimeField   = require("app/components/fields/Time");
const PhoneField  = require("app/components/fields/Phone");
const moment      = require("moment");
const PropTypes   = require("prop-types");
const queryObject = require("app/util/queryObject");
const Tooltip     = require("app/components/mixins/Tooltip");
const router      = require("app/services/router");
const axios       = require("axios");
const Trans       = require('app/components/trans/Trans')

class RecipientForm extends Form {

    static get propTypes() {
        return assign({}, super.propTypes, {
            cart:       PropTypes.object.isRequired,
            pipelines:  PropTypes.object.isRequired,
            setWarning: PropTypes.func
        });
    }

    static get defaultProps() {
        return {
            performValidationOnLoad: true
        };
    }

    constructor(props) {
        super(props);

        this.state = assign({}, this.state, {
            cart:                  props.cart,
            datePickerChanged:     false,
            acceptedTodayDelivery: false,
            uncertainDeliveryDate: false,
            deliveryDateError:     null
        });
    }

    componentDidMount() {
        super.componentDidMount();

        this.handleDeliveryWarning();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.cart !== this.cart) {
            this.setState({cart: nextProps.cart});
        }
    }

    get cart() {
        return this.state.cart;
    }

    get pipelines() {
        return this.props.pipelines;
    }

    get displayDeliveryDate() {
        const deliveryDate = this.datePicker.value;

        return moment(deliveryDate).calendar(null, {
            sameDay:  translate('[i dag]'),
            nextDay:  translate('[i morgen]'),
            lastDay:  translate('[i går]'),
            nextWeek: translate('[d.] D/M'),
            lastWeek: translate('[d.] D/M'),
            sameElse: translate('[d.] D/M'),
            });
    }

    isFuneral() {
        return this.cart.productType === "funeral";
    }

    isPickup() {
        return this.cart.delivery === 'pickup';
    }

    buildPayload(form) {
        let formData = super.buildPayload(form);

        // Add delivery date
        formData.append("delivery_date", this.datePicker.value);

        if (this.timePicker) {
            formData.append("delivery_time", this.timePicker.value);
        }

        return formData;
    }

    performSubmit(form) {
        // Set as loading
        this.setState({loading: true});

        let formData = this.buildPayload(form);

        //formData.append("uncertainDeliveryDate", this.state.uncertainDeliveryDate);

        return this.pipelines.recipient.update.dispatch(formData)
                   .then(cart => {
                       this.onComplete(cart);
                       return cart;
                   })
                   .catch(error => {
                       this.onError(error.response.data);
                       throw error;
                   });
    }

    performValidation() {
        const form = this.bodyElement.querySelector("form");

        if (form == undefined) {
            return;
        }

        return this.pipelines.recipient.validate.dispatch(this.buildPayload(form))
                   .then(() => {
                       this.onValidationSuccess();
                   })
                   .catch(error => {
                       this.onValidationError(error.response.data);
                       //throw error;
                   });
    }

    submit() {
        if (this.shouldRenderWarning) {
            this.setState({
              deliveryDateError: translate("Venligst tag en beslutning om leveringsdatoen.")
            });

            return false;
        }

        this.setState({
            deliveryDateError: null
        });

        return this.performSubmit(this.formElement);
    }

    value(query, defaultValue = null) {
        return queryObject(this.cart, query, defaultValue);
    }

    disableDayFn = (date) => {
        const closedDays = env.get("checkout.closedDays", []);

        if (closedDays.includes(moment(date).format('YYYY-MM-DD'))) {
            return date;
        }
    };

    label(label) {
      return this.isFuneral() ? translate('Kirkens :label', {label: label.toLowerCase()}) : label;
    }

    normalizeHoursForDate(date, hoursData) {
        const offset = hoursData.todayOffset;
        const hours  = {
            from: moment().hour(hoursData.from).minute(0).format("HH:mm"),
            to:   moment().hour(hoursData.to).minute(0).format("HH:mm")
        };

        // If today, offset hours
        if (date === moment().format("YYYY-MM-DD")) {
            hours.from = moment().add(offset, "hour").format("HH:mm");
        }

        return hours;
    }

    _onDatePickerChange = (value) => {
        this.setState({
            datePickerChanged:     true,
            acceptedTodayDelivery: false,
            uncertainDeliveryDate: false,
            deliveryDateError:     null
        });

        this.handleDeliveryWarning();

        return this.onChange("deliveryDate")(value);
    };

    _onZipCodeChange = (value) => {
        this.setState({
            acceptedTodayDelivery: false,
            uncertainDeliveryDate: false,
            deliveryDateError:     null
        });

        this.handleDeliveryWarning();

        return this.onChange("zipCode")(value);
    };

    _onAcceptedTodayDelivery = (e) => {
        e.preventDefault();
        this.props.setWarning(true);
        this.setState({acceptedTodayDelivery: true, deliveryDateError: null});
    };

    _onOpenDatePicker = (e) => {
        e.preventDefault();
        this.props.setWarning(false);
        if (this.datePicker) {
            this.datePicker.show();
        }
    };

    _onChooseCondoleancesProduct = (e) => {
        e.preventDefault();
        return this.pipelines.clear.requestAndRedirect.dispatch({
            location: router.route(
                "product-group.show",
                {groupPath: env.get('checkout.special_group_paths.condolences', '')}
            )
        });
    };

    handleDeliveryWarning() {
        if (!this.datePicker || !this.zipCodeElement) return;

        const zipcode = this.zipCodeElement.value;
        const date    = this.datePicker.value;

        axios
            .post(
                router.route("api.deliveryTime.deadline"),
                {zipcode: zipcode, date: date, is_funeral: this.isFuneral()}
            )
            .then(response => {
                const {is_before, allow_past_deadline} = response.data;

                this.setState({
                    uncertainDeliveryDate: !is_before && allow_past_deadline
                });
            });
    }

    renderDatePicker() {
        return (
            <div className="date-picker-wrapper required">
                <DateField ref={el => this.datePicker = el}
                           min={this.value("minDeliveryDate")}
                           disableDayFn={this.disableDayFn}
                           onChange={this._onDatePickerChange}
                           value={this.value("deliveryDate")}/>
                {this.renderError('delivery_date')}
            </div>
        );
    }

    renderTimePicker() {
        if (!this.isFuneral()/* || !this.datePicker || !this.datePicker.value*/) {
            return;
        }

        const date  = this.datePicker ? this.datePicker.value : null;
        const hours = this.normalizeHoursForDate(
            date, env.get("checkout.delivery.funeralHours")
        );
        const defaultValue = this.state.datePickerChanged
            ? null : this.value("deliveryTime");

        return (
            <div className="time-picker-wrapper required">
                <TimeField ref={el => this.timePicker = el}
                           from={hours.from}
                           to={hours.to}
                           onChange={this.onChange("delivery_time")}
                           defaultValue={defaultValue}/>
                {this.renderError("delivery_time")}
            </div>
        );
    }

    renderFuneralDateWarning() {
        return (
            <div className="warning">
              <p className="warning-title"> <Trans> Bemærk deadline er overskredet </Trans> </p>
              <p> <Trans> Vi vil meget gerne hjælpe dig og vi lykkes som oftest, du skal blot
                    være indforstået med følgende
                    betingelser: </Trans> </p>
              <ul>
                    <li><Trans>Kan vi ikke nå frem til det ønskede tidspunkt vil ordren blive
                        annulleret og du får alle pengene
                        retur.</Trans>
                    </li>
                    <li><Trans>Omfatter din ordre et bånd, da vil vi, såfremt det ikke kan lade
                        sig gøre at få dette produceret,
                        bruge pengene fra båndet til flere blomster og sætte teksten fra
                        båndet på et pænt kort.</Trans>
                    </li>
                    <li><Trans>Leveringsgarantien bortfalder</Trans></li>
                </ul>
                <a href="#" className="button" onClick={this._onAcceptedTodayDelivery}>
                    <Trans> Jeg prøver mit held </Trans>
                </a>
                <a href="#" className="button" onClick={this._onChooseCondoleancesProduct}>
                  <Trans> Send en kondolencebuket </Trans>
                </a>
                <p> <Trans> Er du i tvivl, kontakt os på telefon 35 85 80 12 for at høre nærmere. </Trans> </p>
            </div>
      );
    }

    renderRegularDateWarning() {
        const display = this.displayDeliveryDate;

        return (
            <div className="warning standard">
                <p className="warning-title"><Trans>Bemærk deadline for levering {display} er overskredet</Trans></p>
                <p><Trans>Vi kan IKKE garantere din hilsen leveres {display}, lykkedes det os ikke,
                    leverer vi næste hverdag.</Trans></p>
                <a href="#" className="button" onClick={this._onOpenDatePicker}>
                  <Trans>Skift dato til levering</Trans>
                </a>
                <a href="#" className="button" onClick={this._onAcceptedTodayDelivery}>
                  <Trans> Jeg prøver mit held </Trans>
                </a>
                <p><Trans>Jeg ønsker at forsætte bestillingen og håber den kommer ud {display} og er
                    indforstået med, at der leveres
                    næste hverdag hvis det ikke lykkedes.
                    Jeg forstår at min bestilling ikke kan fortrydes efter kl. 16.00 dags
                    dato.</Trans></p>
                <p><Trans>Er du i tvivl, kontakt os på telefon 35 85 80 12 for at høre
                    nærmere.</Trans></p>
            </div>
        );
    }

    get shouldRenderWarning() {
        const {acceptedTodayDelivery, uncertainDeliveryDate} = this.state;

        return !acceptedTodayDelivery && uncertainDeliveryDate;
    }

    renderDateWarning() {
        if (this.shouldRenderWarning) {
            return this.isFuneral()
                ? this.renderFuneralDateWarning()
                : this.renderRegularDateWarning();
        }
    }

    renderDateError() {
        const {deliveryDateError} = this.state;

        if (deliveryDateError) {
            return (<div className="status-error">{deliveryDateError}</div>);
        }
    }

    renderFuneralTimetooltip() {
        return this.isFuneral()
          ? <Tooltip content={ translate('Angiv tidspunktet for hvornår begravelsen/bisættelsen starter. Vi ankommer altid i god tid inden ceremonien starter.')} />
            : null;
    }

    renderDateTime() {
        const message = this.isFuneral() ?
          translate('Leveringsdato og begravelsestidspunkt') :
          translate('Dato for levering/afhentning');

        return (
            <div className="delivery-date-time">
                <div className="section-title">
                    {message}
                    {this.renderFuneralTimetooltip()}
                </div>
                {this.renderDatePicker()}
                {this.renderTimePicker()}
                {this.renderDateWarning()}
                {this.renderDateError()}
            </div>
        );
    }

    renderOccasionOptions() {
        return env.get("checkout.occasions").map(occasion => {
            return (
                <option key={occasion.id} value={occasion.id}>{occasion.name}</option>
            );
        });
    }

    renderOccasion() {
        if (this.isFuneral()) return null;

        return (
            <div className="occasion-picker">
                <div className="section-title">
                  <Trans> Vælg en anledning </Trans>
                    <Tooltip content={ translate('Angivelse af anledning hjælper blomsterdekoratøren med at lave et produkt der lever op til forventningen.')} />
                </div>
                <p className="hide-mobile"> <Trans> Vælg en anledning så floristen har en ide om hvad din bestilling drejer sig om </Trans> </p>
                <p className="hide-desktop"> <Trans> Giv indsigt i hvad din bestilling drejer sig om </Trans> </p>

                <select defaultValue={this.value("occasion")} name="occasion_id">
                    {this.renderOccasionOptions()}
                </select>
            </div>
        );
    }

    renderDropOptions() {
        if (this.isFuneral() || this.isPickup()) {
            return;
        }

        return (
            <div className="drop-options">
              <div className="section-title">
                <Trans> Hvis modtageren ikke er hjemme? </Trans>
                <Tooltip content={ translate('Så tages produktet med retur, vi lægger en besked i postkassen eller kontakter modtageren pr. telefon hvis der ikke er anden mulighed. Du kan give os lov til at sætte hilsenen ved døren eller hos naboen, bemærk at dette sker på dit ansvar.')} positionMobile="sw"/>
              </div>
              <p className="hide-mobile"> <Trans> Vær opmærksom på at Bloomit ikke erstatter eventuelt bortkomne bestillinger,
                som du har givet os tilladelse til at sætte ved døren eller aflevere hos naboen. </Trans> </p>
              <p className="hide-desktop"> <Trans> Vi erstatter ikke bortkomne bestillinger. </Trans> </p>
              <div className="field checkbox-field">
                <input id="leaveAtDoorCheckbox" type="checkbox" name="leave_at_door"
                       value="1"
                       defaultChecked={this.value("recipient.can_leave_at_door")}/>
                <label htmlFor="leaveAtDoorCheckbox"><Trans>Må sættes ved døren</Trans></label>
                <Tooltip
                  content={ translate('Når vi MÅ sætte et produkt ved døren sker det ALTID på kundens eget ansvar. Vi hjælper dig, i det vi altid foretager en individuel vurdering af risikoen for tyveri og vejrlig (hård sol/frost), det er derfor buddets afgørelse om produktet sættes. SKAL produktet sættes uanset forholdende så noter venligst dette!')}/>
              </div>
              <div className="field checkbox-field">
                <input id="leaveAtNeighbourCheckbox" type="checkbox"
                       name="leave_at_neighbour" value="1"
                       defaultChecked={this.value(
                         "recipient.can_leave_at_neighbour")}/>
                <label htmlFor="leaveAtNeighbourCheckbox"><Trans>Må sættes ved naboen</Trans></label>
                <Tooltip
                  content={ translate('Dette betyder, at vi forsøger levering til den nærmeste nabo, og kun én nabo, hvis denne er i gå afstand. Er denne ikke hjemme, tages produktet med retur.') } />
              </div>
            </div>
        );
    }

    renderPhoneField() {
        if (this.isFuneral()) {
            return;
        }

        return (
            <div className="field required">
                <label htmlFor="phoneInput">
                  <Trans>Telefon nr. </Trans>
                    <Tooltip content={ translate('Anvendes sjældent, men fx i forbindelse med at opgang, indkørsel eller lign. ikke kan findes.')} positionMobile="se" />
                </label>
                {this.renderValidity("phone")}
                <PhoneField defaultValue={this.value("recipient.phone", "")}
                            id="phoneInput"
                            name= "phone" required={true}
                            onInput={this.onChange("phone")}
                            placeholder={ translate('Fx. 35858012')} />
                {this.renderError("phone")}
            </div>
        );
    }

    renderCompanyField() {
        const required  = this.isFuneral();
        const className = this.isFuneral() ? 'field required' : 'field';

        let content = (
            <React.Fragment>
              {this.label(translate('Firma') )}
                <Tooltip content={ translate('Befinder modtager sig i et firma på leveringsdagen, er det vigtigt at firmanavnet bliver oplyst, samt evt. afdeling eller afsnit.')} positionMobile="se" />
            </React.Fragment>
        );

        if (this.isFuneral()) {
            content = (
                <React.Fragment>
                    {this.label(translate('Navn') )}
                    <Tooltip content={ translate('Angiv kirkens navn. Skal leverings ske til privat adresse, skriv da i dette felt: ’Sendes til Privat Adresse’ ')} positionMobile="se" />
                </React.Fragment>
            );
        }

        return (
            <div className={className}>
                <label htmlFor="companyInput">
                    {content}
                </label>
                {this.renderValidity("company")}
                <input id="companyInput" name="company" type="text"
                       onInput={this.onChange("company")} required={required}
                       defaultValue={this.value("recipient.company", "")}
                       placeholder= { translate("Fx. Bloomit Danmark ApS") }  />
                {this.renderError("company")}
            </div>
        );
    }

    renderLateNameField() {
        let content = translate( 'Modtagers navn' );
        let field   = 'nameInput';

        if (this.isFuneral()) {
            field   = 'lateNameInput';
            content = (
                <React.Fragment>
                  <Trans> Afdødes navn </Trans>
                    <Tooltip content={ translate("Oplys venligst afdødes fulde navn. Kælenavne vanskeliggør en korrekt levering.") } positionMobile="se"  />
                </React.Fragment>
            );
        }

        return (
            <div className="field required">
                <label htmlFor={field}>
                    {content}
                </label>
                {this.renderValidity("name")}
                <input id={field} name="name" type="text"
                       onInput={this.onChange("name")} required={true}
                       defaultValue={this.value("recipient.name", "")}
                       placeholder= { translate("Fx. Elisabeth Hansen")} />
                {this.renderError("name")}
            </div>
        );
    }

    renderRecipient() {

        if (this.isPickup()) return null;

        return (
            <React.Fragment>
                <div className="section-title hide-mobile"><Trans>Modtagers oplysninger</Trans></div>
                <div className="inputs">
                    {this.renderLateNameField()}
                    {this.renderPhoneField()}
                    {this.renderCompanyField()}

                    <div className="field required">
                        <label htmlFor="addressInput">
                            {this.label(translate('Adresse') )}
                            <Tooltip content={ translate("Vær omhyggelig med at udfylde korrekt og fyldestgørende adresse. Skriv her gade/vejnavn, husnummer, etage, lejlighedsnummer eller lokalenummer. I store organisationer som fx hospitaler, universiteter, er det ofte afgørende med alle detaljer for at lykkedes med afleveringen.")} positionMobile="se" />
                        </label>
                        {this.renderValidity("address")}
                        <input defaultValue={this.value("recipient.address", "")}
                               type="text"
                               id="addressInput" name="address"
                               required={true}
                               onInput={this.onChange("address")}
                               placeholder={ translate("Fx. H. C. Andersensvej 1") } />
                        {this.renderError("address")}
                    </div>

                    <div className="field required">
                        <label htmlFor="zipCodeInput">
                            {this.label( translate('Postnr.'))}
                        </label>
                        {this.renderValidity("zipCode")}
                        <ZipField ref={el => this.zipCodeElement = el} name="zipCode"
                                  zip={this.value("recipient.zipcode", "")}
                                  city={this.value("recipient.city", "")}
                                  zipPlaceholder= { translate("Fx. 5000")}
                                  cityPlaceholer= { translate("Odense")}
                                  region={this.value("recipient.region", "")}
                                  required={true}
                                  onChange={this._onZipCodeChange}/>
                        {this.renderError("zipCode")}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <form ref={el => this.formElement = el} onSubmit={this.onSubmit}>
                {this.renderError("status", "status-error")}

                {this.renderRecipient()}
                {this.renderDateTime()}
                {this.renderOccasion()}
                {this.renderDropOptions()}
            </form>
        );
    }

}

module.exports = RecipientForm;
